<template>
	<div>
		<ArticleExpMedium class="max-h-[200px] mx-auto" :medium-id="article?.primaryImage" :preset="mediumPreset" />
		<ArticleEnergyEfficiency class="justify-end flex" :article="article" :label-text-size="28" :label-svg-size="20" />
		<ArticleExhibitFlag :exhibit-info="item?.itemOnDisplay" />
	</div>
</template>

<script setup lang="ts">
defineProps<{ 
	article: any;
	item: OrderItem;
}>()

const mediumPreset = computed(() => {
  return useDevice()?.isDesktop ? 'orderArticleImage' : 'preview';
});
</script>

<style scoped lang="postcss">
img {
  max-width: none;
}
</style>
